import { getCallable } from "../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    GetWorkspaceResourceFoldersRequest, GetWorkspaceResourceFoldersResponse,
    UpdateWorkspaceResourceFolderRequest, UpdateWorkspaceResourceFolderResponse,
    DeleteWorkspaceResourceFolderRequest, DeleteWorkspaceResourceFolderResponse,
    CreateWorkspaceResourceFolderRequest, CreateWorkspaceResourceFolderResponse,
    AddResourcesToWorkspaceResourceFolderRequest, AddResourcesToWorkspaceResourceFolderResponse,
    RemoveResourcesFromWorkspaceResourceFolderRequest, RemoveResourcesFromWorkspaceResourceFolderResponse,
    UpdateWorkspaceResourceFolderMembersRequest, UpdateWorkspaceResourceFolderMembersResponse
} from "./types";

export { apiName };

const getWorkspaceResourceFolders = getCallable<GetWorkspaceResourceFoldersRequest, GetWorkspaceResourceFoldersResponse>(
    apiName,
    "getWorkspaceResourceFolders",
    {
        ...endpoints.getWorkspaceResourceFolders,
        composer: request => {
            const queryParams = new URLSearchParams();
            if (request.folderIds) {
                queryParams.set("folderIds", JSON.stringify(request.folderIds));
            }
            if (request.includeImplicitPermissions) {
                queryParams.set("includeImplicitPermissions", "true");
            }

            return {
                url: `/workspaces/${request.workspaceId}/resource-folders?${queryParams.toString()}`,
                options: {
                    method: "GET"
                }
            };
        }
    }
);

const updateWorkspaceResourceFolder = getCallable<UpdateWorkspaceResourceFolderRequest, UpdateWorkspaceResourceFolderResponse>(
    apiName,
    "updateWorkspaceResourceFolder",
    {
        ...endpoints.updateWorkspaceResourceFolder,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/resource-folders/${request.folderId}`,
                options: {
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            };
        }
    }
);

const deleteWorkspaceResourceFolder = getCallable<DeleteWorkspaceResourceFolderRequest, DeleteWorkspaceResourceFolderResponse>(
    apiName,
    "deleteWorkspaceResourceFolder",
    {
        ...endpoints.deleteWorkspaceResourceFolder,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/resource-folders/${request.folderId}`,
                options: {
                    method: "DELETE"
                }
            };
        }
    }
);

const createWorkspaceResourceFolder = getCallable<CreateWorkspaceResourceFolderRequest, CreateWorkspaceResourceFolderResponse>(
    apiName,
    "createWorkspaceResourceFolder",
    {
        ...endpoints.createWorkspaceResourceFolder,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/resource-folders`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    }
);

const addResourcesToWorkspaceResourceFolder = getCallable<AddResourcesToWorkspaceResourceFolderRequest, AddResourcesToWorkspaceResourceFolderResponse>(
    apiName,
    "addResourcesToWorkspaceResourceFolder",
    {
        ...endpoints.addResourcesToWorkspaceResourceFolder,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/resource-folders/${request.folderId}/resources`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    }
);

const removeResourcesFromWorkspaceResourceFolder = getCallable<RemoveResourcesFromWorkspaceResourceFolderRequest, RemoveResourcesFromWorkspaceResourceFolderResponse>(
    apiName,
    "removeResourcesFromWorkspaceResourceFolder",
    {
        ...endpoints.removeResourcesFromWorkspaceResourceFolder,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/resource-folders/${request.folderId}/resources`,
                options: {
                    method: "DELETE",
                    body: JSON.stringify(request)
                }
            };
        }
    }
);

const updateWorkspaceResourceFolderMembers = getCallable<UpdateWorkspaceResourceFolderMembersRequest, UpdateWorkspaceResourceFolderMembersResponse>(
    apiName,
    "updateWorkspaceResourceFolderMembers",
    {
        ...endpoints.updateWorkspaceResourceFolderMembers,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/resource-folders/${request.folderId}/members`,
                options: {
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            };
        }
    }
);

export const callables = {
    getWorkspaceResourceFolders,
    updateWorkspaceResourceFolder,
    deleteWorkspaceResourceFolder,
    createWorkspaceResourceFolder,
    addResourcesToWorkspaceResourceFolder,
    removeResourcesFromWorkspaceResourceFolder,
    updateWorkspaceResourceFolderMembers
};

